import { render, staticRenderFns } from "./EndBatchModal.vue?vue&type=template&id=5008c951&scoped=true&"
import script from "./EndBatchModal.vue?vue&type=script&lang=js&"
export * from "./EndBatchModal.vue?vue&type=script&lang=js&"
import style0 from "./EndBatchModal.vue?vue&type=style&index=0&id=5008c951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008c951",
  null
  
)

export default component.exports